import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './baseFectch';

export const salarySlipApi = createApi({
  reducerPath: 'salarySlip',
  baseQuery: baseQueryWithReauth,
  tagTypes: [
    'generateSalarySlip',
    'exportSalarySlip',
    'updateEmployeeSalary',
    'fetchSalarySlip',
    'salaryData',
  ],
  endpoints: (builder) => ({
    generateEmployeeSlip: builder.query<
      any,
      { employeeId: string; date: string }
    >({
      query: ({ employeeId, date }) => ({
        url: `/generateSlip/${employeeId}/${date}`,
      }),
      providesTags: ['salaryData'],
    }),

    updateEmployeeSalaryBanks: builder.mutation<any, any>({
      query: ({ _id, salaryDetails, bankDetails, companyId }) => ({
        url: `/${companyId}/${_id}/update-salary-bank`,
        method: 'PATCH',
        body: { salaryDetails, bankDetails },
      }),
    }),
  }),
});

export const {
  useLazyGenerateEmployeeSlipQuery,
  useUpdateEmployeeSalaryBanksMutation,
} = salarySlipApi;
